import { render, staticRenderFns } from "./DisplayWishList.vue?vue&type=template&id=203d749d&"
import script from "./DisplayWishList.vue?vue&type=script&lang=js&"
export * from "./DisplayWishList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports